import {inject, Injectable} from '@angular/core';
import {RouterStateSnapshot, TitleStrategy} from "@angular/router";
import {Title} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class PortalTitleStrategy extends TitleStrategy {

  private readonly title = inject(Title);
  private readonly appName = 'Portal';

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const built = this.buildTitle(snapshot); // uses route data.title
    this.title.setTitle(built ? `${built} | ${this.appName}` : this.appName);
  }
}
